import React from 'react';
import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

// Modules
import { AppError } from '@/modules/Errors';
import { MainLayout, AuthLayout } from '@/modules/Layout';

// Models
import { IRouteConfig, ROUTES } from '@/models/router.model';

// Components
import { SignIn, NotFound, ResetPassword } from '@/pages';
import ProtectedRoute from '../containers/ProtectedRoute/ProtectedRoute';

// Config
import { routesConfig } from '../constants/config';

type ValueOrArray<T> = T | ValueOrArray<T>[];

const mapRoute = (route: IRouteConfig): ValueOrArray<JSX.Element> => {
  return <Route path={route.path} element={route.component} key={route.path} />;
};

const routes = routesConfig.map(mapRoute);

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<AuthLayout />}>
        <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
      </Route>
      <Route element={<AuthLayout />}>
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />} errorElement={<AppError />}>
          {routes}
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Route>,
  ),
);
